module.exports = __webpack_public_path__ + "img/check_circle_FILLYELLOW_wght600_GRAD0_opsz48 1.4579c330.svg";